module.exports = __webpack_public_path__ + "media/public/images/social/facebook-a2461d76023fbd7f7daf75704a0eaea0.svg";